import { getSettingsBaseUrl } from './getSettingsBaseUrl';
import PortalIdParser from 'PortalIdParser';
export const getSettingsRootUrl = () => `${getSettingsBaseUrl()}/${PortalIdParser.get()}`;